import { IUserNotificationSetting } from '../../models/IUserNotificationsSettingsInfo';

export namespace UserNotificationsSettingsFormUtils {
  const keySeparator = '__';

  export function toSettingKey(setting: {notificationBucket: string, channel: string}): string {
    return `${setting.notificationBucket}${keySeparator}${setting.channel}`;
  }

  export function fromSettingKey(settingKey: string): Pick<IUserNotificationSetting, 'channel' | 'notificationBucket'> {
    const [bucketId, channelId] = settingKey.split(keySeparator);
    return {
      notificationBucket: bucketId,
      channel: channelId
    };
  }

}